import { Middleware, Dispatch, MiddlewareAPI } from 'redux';
import { } from 'react';
import { GlobalState } from '../models';
import { FSA } from 'flux-standard-action';
import { RequestApiMeta, RequestApiHttpPayload } from 'loopback-react-request';
import { configurationDefaults } from 'franke-trough-dependencies';
import { warnings } from './warnings.action';

export const warningsMiddleware = (): Middleware => (store: MiddlewareAPI) => 
  (next: Dispatch) => 
    (action: FSA<string, any, RequestApiMeta & {options?: RequestApiHttpPayload & {key: string}}>)  => {
      const meta = action.meta;
      const isActionId = meta && meta.id === 'configuration';
      const isActionType = String(action.type) === '@ReduxHttpRequest/LOAD_SUCCEEDED_CONFIGURATION';
      
      const prevState = store.getState();
      const returnValue = next(action);
      const nextState = store.getState();

      if (isActionId && isActionType) {   
        const configuration = nextState.configuration.result;
        const prevDefaults = prevState.configuration.result && prevState.configuration.result.defaults;
        
        const isDetail = configuration && isConfigurationDetail(configuration.id, nextState.router.location);

        if (configuration && isDetail) {          
          if (configuration.selectedTrough && configuration.troughId) {
            configuration.defaults.selectedTrough.troughId = configuration.troughId;
          }

          store.dispatch(warnings.changed({
            configuration, 
            defaults: prevDefaults || configurationDefaults,
            initialRequest: prevDefaults === undefined ? true : false,
          }));
        }
      }
      return returnValue;
    };

export const isConfigurationDetail = (configurationId: string, location: GlobalState['router']['location']): boolean => {
  switch (location.pathname) {
    case `/configuration/${configurationId}/rename`:
    case `/configuration/${configurationId}/country`:
    case `/configuration/${configurationId}/duplicate`:
    case `/configuration/${configurationId}/delete`:
    case `/configuration/${configurationId}/archive`:
    case `/configuration/${configurationId}/unarchive`:
    case `/configuration/${configurationId}/project`:
    case `/configuration/${configurationId}/checkout`:
      return false;
    default:
      return true;
  }
};